export default __webpack_public_path__ + "static/O0170-c815460d7e51bebfef423a1656a4f651.png";